import ReactMarkdown from 'react-markdown'
import { Light as SyntaxHighlighter } from 'react-syntax-highlighter'
import atomOneLight from 'react-syntax-highlighter/dist/esm/styles/hljs/atom-one-light'
import remarkGfm from 'remark-gfm'

import styles from './DirectfulAssist.module.scss'

const syntaxHighlighterStyle = {
  ...atomOneLight,
  hljs: {
    ...atomOneLight.hljs,
    display: 'block',
    overflowX: 'auto',
    padding: '10px 12px',
    borderRadius: '8px',
    fontSize: '12px',
    lineHeight: 1.45,
    background: '#f3f4f6'
  }
}

const AssistMessageContent = ({ text }) => {
  if (!text) return null

  return (
    <div className={styles.markdownContent}>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          a: ({ node, ...props }) => (
            <a {...props} target="_blank" rel="noopener noreferrer" />
          ),
          table: ({ node, ...props }) => (
            <div className={styles.tableWrap}>
              <table {...props} />
            </div>
          ),
          code: ({ node, inline, className, children, ...props }) => {
            const match = /language-(\w+)/.exec(className || '')
            const content = String(children).replace(/\n$/, '')

            if (!inline && match) {
              return (
                <SyntaxHighlighter
                  style={syntaxHighlighterStyle}
                  language={match[1]}
                  PreTag="div"
                  customStyle={{ margin: '0 0 8px' }}
                >
                  {content}
                </SyntaxHighlighter>
              )
            }

            return (
              <code className={className} {...props}>
                {children}
              </code>
            )
          }
        }}
      >
        {text}
      </ReactMarkdown>
    </div>
  )
}

export default AssistMessageContent
